module.exports = __webpack_public_path__ + "img/31.b47501bd.jpg";